module.exports = __webpack_public_path__ + "img/location-gems.30209921.jpg";